// import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.aw_native_slider');

  if (!sliders) return;
  let i = 0;
  sliders.forEach((slider) => {
    i++;
    new AW_Native_Slider(slider, i, sliders.length);
  });
});

class AW_Native_Slider {
  constructor(slider, i, sliderCount) {
    this.slider = slider;
    this.slidersOnDOM = sliderCount;
    this.slideList = this.slider.querySelector('.aw_native_slider__list');
    this.slideList.tabIndex = `${i}`;
    this.slides = this.slider.querySelectorAll('.aw_native_slider__slide');
    this.firstSlide = this.slides[0];
    this.lastSlide = this.slides[this.slides.length - 1];
    this.showNavigation = this.slider.dataset.showNavigation;
    this.index = this.slider.dataset.index;
    this.slideCount = this.slides.length;
    this.currentSlideIndex = 0;
    this.paginationContainer = false;
    this.progressContainer;
    this.init();
    this.slideMode = this.slider.dataset.slideMode;
  }

  init() {
    if (this.showNavigation === 'true') {
      this.createNavButton('left');
      this.createNavButton('right');
    }

    this.eventHandler();
    this.activeSlideObserver();

    if (
      this.index === 'progress' ||
      this.slider.matches('.aw_yellow_box_slider')
    ) {
      this.createProgress();

      this.slider.dataset.index = 'progress';
      this.index = 'progress';
    } else {
      this.createPagination();
    }
  }

  createNavButton(position) {
    const navBtn = document.createElement('button');
    navBtn.dataset.direction = position;
    navBtn.classList.add('aw_nav_button', 'aw_' + position);
    navBtn.innerText = position === 'left' ? '<' : '>';
    this.slider.appendChild(navBtn);
    this.slider.dataset.currentIndex = 0;
    this.progressWrapper = '';
    this.progressBar = '';
    this.skipToFirst = '';
  }

  eventHandler() {
    this.slider.addEventListener('click', (e) => {
      if (
        !e.target.matches('.aw_nav_button') &&
        !e.target.matches('.aw_native_slider__slide * ')
      )
        return;

      //Click on arrows
      if (e.target.matches('.aw_nav_button')) {
        const direction = e.target.dataset.direction;

        let nextSlideIndex = this.nextSlideIndex;

        direction === 'right' ? nextSlideIndex++ : nextSlideIndex--;

        this.moveToSlide(nextSlideIndex);
      }

      // if (this.slideCount > 3) {
      //   let scrollPx = 0;
      //   this.slideList.addEventListener('wheel', (e) => {
      //     e.preventDefault();

      //     scrollPx += e.deltaY;

      //     console.log(scrollPx);

      //     this.slideList.scroll({
      //       top: 0,
      //       left: scrollPx,
      //       behavior: 'smooth'
      //     });
      //   });
      // }

      //Click on slide
      if (!e.target.matches('.aw_native_active *')) {
        let slideIndex = e.target.dataset.slideIndex;

        if (!slideIndex) {
          slideIndex = e.target.closest('.aw_native_slider__slide').dataset
            .slideIndex;
        }

        this.moveToSlide(slideIndex);
      }
    });

    if (this.slidersOnDOM > 1) return;
    document.addEventListener('keydown', (e) => {
      let nextSlideIndex = this.nextSlideIndex;
      if (e.keyCode === 37) {
        // console.log('left');
        nextSlideIndex--;
      }

      if (e.keyCode === 39) {
        // console.log('right');
        nextSlideIndex++;
      }

      this.moveToSlide(nextSlideIndex);
    });
  }

  get nextSlideIndex() {
    const currentSlide = this.slider.querySelector('.aw_native_active');
    if (!currentSlide) return false;
    let nextSlideIndex = +currentSlide.dataset.slideIndex;

    return nextSlideIndex;
  }

  moveToSlide(nextSlideIndex) {
    const nextSlideElement = this.slider.querySelector(
      `[data-slide-index="${nextSlideIndex}"]`
    );

    this.currentSlideIndex = nextSlideIndex;
    this.slider.dataset.currentIndex = this.currentSlideIndex;

    if (!nextSlideElement) return;

    nextSlideElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  activeSlideObserver() {
    const slides = this.slides;
    //let currentSlide = false;
    let i = 0;
    let options = {
      root: this.slider,
      rootMargin: '0px',
      threshold: 1
    };

    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.slideActive = entry.target;

          this.currentSlideIndex = entry.target.dataset.slideIndex;

          if (this.slideCount - 1 === +this.currentSlideIndex) {
            this.slider.dataset.lastSlide = true;
          } else {
            this.slider.dataset.lastSlide = false;
          }

          this.slider.dataset.currentIndex = this.currentSlideIndex;
        } else {
          this.slideDeactive = entry.target;
        }

        if (
          this.lastSlide === entry.target ||
          this.firstSlide === entry.target
        ) {
          this.checkIfSlidesAreOffScreen();
        }
      });
    }, options);

    slides.forEach((slide) => {
      slide.dataset.slideIndex = i++;
      observer.observe(slide);
    });
  }

  checkIfSlidesAreOffScreen() {
    // Remove Slider Functionality if no slides are off screen

    if (
      this.firstSlide.matches('.aw_native_active') &&
      this.lastSlide.matches('.aw_native_active') &&
      this.slideCount <= 3
    ) {
      this.hidePagination();
      this.disableSlider(true);
    } else {
      this.showPagingation();
      this.disableSlider(false);
    }
  }

  hidePagination() {
    if (this.index !== 'progress') {
      this.paginationContainer.remove();
      this.paginationContainer = false;
    } else {
      this.progressContainer.style.visibility = 'hidden';
    }
  }

  showPagingation() {
    if (this.index !== 'progress') {
      this.createPagination();
    } else {
      this.progressContainer.style.visibility = 'visible';
    }
  }

  disableSlider(state) {
    if (state) {
      this.slideList.style.overflowX = 'hidden';
    } else {
      this.slideList.style.overflowX = 'scroll';
    }
  }

  createPagination() {
    if (this.paginationContainer) return;

    const slideCount = this.slideCount;
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.classList.add('aw_pagination_container');
    let paginationList = '';

    for (let i = 0; i < slideCount; i++) {
      paginationList += `
      <li class="${i === 0 ? 'aw_is_active' : ''}" data-index="${i}">${i}
      </li>`;
    }

    this.paginationContainer.innerHTML = `
  
      <div class="aw_row">
        <div class="col_12" >
          <ul class="aw_native_slider__pagination">
            ${paginationList}
          </ul>
        </div>
      </div>
   
  `;

    this.initPaginationEventHandler(this.paginationContainer);

    this.slider.after(this.paginationContainer);
  }

  initPaginationEventHandler(paginationContainer) {
    paginationContainer.addEventListener(
      'click',
      (e) => {
        if (!e.target.matches('.aw_native_slider__pagination *')) return;

        const index = e.target.dataset.index;
        this.moveToSlide(index);
      },
      true
    );
  }

  set activePagination(index) {
    if (this.index === 'progress') return;

    // Remove old active state
    this.paginationContainer
      .querySelector('.aw_is_active')
      .classList.remove('aw_is_active');

    //Highlight current one
    this.paginationContainer
      .querySelector('[data-index="' + index + '"]')
      .classList.add('aw_is_active');
  }

  set slideActive(slide) {
    slide.classList.add('aw_native_active');
    this.activePagination = slide.dataset.slideIndex;

    this.updateLastSlideState();
    this.updateFirstSlideState();
  }
  set slideDeactive(slide) {
    slide.classList.remove('aw_native_active');
  }

  updateFirstSlideState() {
    if (this.slides[0].matches('.aw_native_active')) {
      this.slider.dataset.firstSlide = true;
    } else {
      this.slider.dataset.firstSlide = false;
    }
  }

  updateLastSlideState() {
    if (this.lastSlide.matches('.aw_native_active')) {
      this.slider.dataset.lastSlide = true;
    } else {
      this.slider.dataset.lastSlide = false;
    }
  }

  createProgress() {
    //if (this.overflow) return;
    this.progressContainer = document.createElement('div');
    this.progressContainer.classList.add('aw_native_slider_progress_container');
    this.slider.appendChild(this.progressContainer);

    this.skipToFirst = document.createElement('div');
    this.skipToFirst.classList.add('aw_native_slider_skip');
    this.initSkipEventHanlder();

    this.skipToFirst.innerHTML = `
    <div class="aw_ns_arrow_left">
      <div class="aw_ns_arrow_part_top"></div>
      <div class="aw_ns_arrow_part_bottom"></div>
    </div>
    <div class="aw_ns_arrow_right">
      <div class="aw_ns_arrow_part_top"></div>
      <div class="aw_ns_arrow_part_bottom"></div>
    </div>
    `;
    this.progressContainer.appendChild(this.skipToFirst);

    this.progressBar = document.createElement('input');
    this.progressBar.classList.add('aw_progress_range_slider');
    this.progressBar.type = 'range';
    this.progressBar.min = 0;
    this.progressBar.max = 100;
    this.progressBar.step = '0.1';
    this.progressBar.value = 0;

    this.progressContainer.appendChild(this.progressBar);

    this.progressBar.addEventListener('input', (e) => {
      const value = +e.target.value;

      this.slideList.scroll({
        top: 0,
        left: this.maxScroll * 0.01 * value,
        behavior: 'smooth'
      });

      this.toggleSkipButton();
    });

    this.progressBar.addEventListener('mousedown', (e) => {
      e.target.dataset.isActive = 'true';
    });

    this.progressBar.addEventListener('mouseup', (e) => {
      e.target.dataset.isActive = 'false';
    });

    let currentScroll = 0;

    this.slideList.addEventListener('scroll', (e) => {
      if (this.progressBar.dataset.isActive === 'true') return;

      currentScroll = e.target.scrollLeft;

      let scrollProgress = 0;
      scrollProgress = Math.round((currentScroll / this.maxScroll) * 100);
      this.progressBar.value = scrollProgress;

      this.toggleSkipButton();
    });
  }

  toggleSkipButton() {
    const scrollProgress = this.progressBar.value;

    if (scrollProgress > 99) {
      this.slider.dataset.showSkip = 'true';
    } else {
      this.slider.dataset.showSkip = 'false';
    }
  }

  // createProgress() {
  //   //if (this.overflow) return;
  //   this.progressContainer = document.createElement('div');
  //   this.progressContainer.classList.add('aw_native_slider_progress_container');
  //   this.slider.appendChild(this.progressContainer);

  //   this.skipToFirst = document.createElement('div');
  //   this.skipToFirst.classList.add('aw_native_slider_skip');
  //   this.initSkipEventHanlder();

  //   this.skipToFirst.innerHTML = `
  //   <div class="aw_ns_arrow_left">
  //     <div class="aw_ns_arrow_part_top"></div>
  //     <div class="aw_ns_arrow_part_bottom"></div>
  //   </div>
  //   <div class="aw_ns_arrow_right">
  //     <div class="aw_ns_arrow_part_top"></div>
  //     <div class="aw_ns_arrow_part_bottom"></div>
  //   </div>
  //   `;
  //   this.progressContainer.appendChild(this.skipToFirst);

  //   this.progressWrapper = document.createElement('div');
  //   this.progressWrapper.classList.add('aw_native_slider_progress_wrapper');

  //   this.progressContainer.appendChild(this.progressWrapper);

  //   this.progressBar = document.createElement('div');
  //   this.progressBar.classList.add('aw_native_slider_progress_bar');
  //   this.progressWrapper.appendChild(this.progressBar);

  //   let currentScroll = 0;

  //   this.slideList.addEventListener('scroll', (e) => {
  //     currentScroll = e.target.scrollLeft;

  //     let scrollProgress = 0;
  //     scrollProgress = Math.round((currentScroll / this.maxScroll) * 100);
  //     this.progressBar.style.transform = `translateX(${this.getProgressBarPosition(
  //       scrollProgress
  //     )}px)`;
  //   });
  // }

  initSkipEventHanlder() {
    this.skipToFirst.addEventListener('click', () => {
      this.moveToSlide(0, 'left');
    });
  }

  get overflow() {
    return this.slideList.clientWidth >= this.slideList.scrollWidth;
  }

  get maxScroll() {
    return this.slideList.scrollWidth - this.slideList.offsetWidth;
  }

  getProgressBarPosition(scrollProgress) {
    const wrapperWidth = this.progressWrapper.clientWidth;
    const barWidth = this.progressBar.clientWidth;

    const newPosition = Math.round(
      scrollProgress * 0.01 * (wrapperWidth - barWidth)
    );

    return newPosition;
  }
}

//Older Slider

// document.addEventListener('DOMContentLoaded', () => {
//   if (document.querySelector('.splide')) {
//     initSlider(document.querySelectorAll('.aw_project_slider'), 'project')
//     initSlider(document.querySelectorAll('.aw_donation_slider'), 'donation')
//     initSlider(document.querySelectorAll('.aw_post_archive_slider'), 'archive')
//   }
// })

// function initSlider(sliders, theme) {
//   let breakpoints = {}

//   if (theme === 'project') {
//     breakpoints = calcBreakPointsProjects()
//   }

//   if (theme === 'donation') {
//     breakpoints = calcBreakPointsDonation()
//   }

//   if (theme === 'archive') {
//     breakpoints[5000] = {
//       gap: '2rem',
//       perPage: 3
//     }

//     breakpoints[800] = {
//       gap: '2rem',
//       perPage: 2
//     }

//     breakpoints[482] = {
//       gap: '2rem',
//       perPage: 1
//     }
//   }

//   sliders.forEach((slider) => {
//     const moduleId = slider.id

//     const splide = new Splide(`#${moduleId}`, {
//       type: theme === 'project' ? 'loop' : 'slide',
//       arrows: false,
//       rewind: true,
//       lazyLoad: 'sequential',
//       preloadPages: 1,
//       breakpoints: breakpoints
//     })

//     splide.on('pagination:mounted', function (data) {
//       // You can add your class to the UL element
//       const labels = document.querySelectorAll(
//         `#${moduleId} ul.splide__list li`
//       )

//       // `items` contains all dot items
//       data.items.forEach(function (item) {
//         item.button.textContent = String(labels[item.page].ariaLabel)
//       })
//     })

//     splide.on('click', function (e) {
//       splide.go(e.index)
//     })

//     splide.mount()
//   })
// }

// function calcBreakPointsProjects() {
//   let breakpoints = {}
//   //   const maxContentWidth = 1120
//   const maxSlideWidth = 928

//   for (let i = maxSlideWidth + 2 * 24; i < 3220; i++) {
//     breakpoints[i] = {
//       padding: `${(i - maxSlideWidth) / (2 * 16)}rem`,
//       pagination: false,
//       gap: '2rem'
//     }
//   }

//   breakpoints[maxSlideWidth + 2 * 24 - 1] = {
//     padding: `4rem`,
//     gap: '0.5rem'
//   }

//   breakpoints[440] = {
//     padding: `1.5rem`,
//     gap: '0.5rem'
//   }

//   return breakpoints
// }

// function calcBreakPointsDonation() {
//   let breakpoints = {}

//   const maxSlideWidth = 1024

//   for (let i = maxSlideWidth + 2 * 24; i < 3220; i++) {
//     let paddingLeft = (i - maxSlideWidth - maxSlideWidth / 12 - 24) / (2 * 16)
//     let paddingRight = (i - maxSlideWidth + maxSlideWidth / 12 + 24) / (2 * 16)

//     if (paddingLeft < 1.5) paddingLeft = 1.5
//     if (paddingRight < 2.5) paddingLeft = 1.5

//     breakpoints[i] = {
//       padding: {
//         left: `${paddingLeft}rem`,
//         right: `${paddingRight}rem`
//       },
//       gap: '2rem'
//     }
//   }

//   breakpoints[768] = {
//     padding: '1.5rem',
//     gap: '1rem'
//   }

//   return breakpoints
// }

// // console.table(calcBreakPoints())
